export default __webpack_public_path__ + "static/media/bluepinata.b406e144.png";